import { useEffect } from 'react';

export const useDocumentTitle = (title: string, prevailOnUnmount = false, enabled = true) => {
  useEffect(() => {
    if (enabled) {
      document.title = `${title} | Sendit Gigs`;
    }
  }, [title, enabled]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount && enabled) {
        document.title = 'Sendit Gigs';
      }
    },
    [prevailOnUnmount, enabled]
  );
};
